import Axios from "axios";
import * as config from "@/constants/config";
import { authHeader } from "@/services/TokenHelper";

export default {
  controller: "installers",
  GetAllInstallers: function(includeAccesses = false) {
    let url = config.API + this.controller;

    if (includeAccesses) {
      url += "?includeAccesses=true";
    }

    return Axios.get(url, { headers: authHeader() });
  },
  GetInstaller: function(id) {
    return Axios.get(config.API + this.controller + `/${id}`, {
      headers: authHeader()
    });
  },
  CreateInstaller: function(installer) {
    return Axios.post(config.API + this.controller, installer, {
      headers: authHeader()
    });
  },
  UpdateInstaller: function(installer) {
    return Axios.put(
      config.API + this.controller + "/" + installer.id,
      installer,
      {
        headers: authHeader()
      }
    );
  }
};
